<template>
    <div class="service--generic" v-if="service.length !== 0">
        <b-row>
            <b-col cols="10" offset="1">
                <b-form-group id="freetext">
                    <tiny-mce
                        :preview_mode="true"
                        :height="400"
                        :block_title="'Informazioni servizio'"
                        :initial_value="this.generic_service.details.freetext"
                        @input="(value) => {
                            this.generic_service.details.freetext = value
                            this.update_service()
                        }"
                    />
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import TinyMce from '@/components/blocks/tiny-mce'
export default {
    name: 'generic',
    components: {
        'tiny-mce': TinyMce,
    },
    props: {
        service: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {     
            generic_service: this.service
        }
    },
    created()
    {
    },
    mounted() {
    },
    methods:{
        update_service()
        {
            this.$store.commit('set_service', {
                service: this.generic_service
            })
        }, 
    },
    computed: {
    }
}
</script>

<style lang="scss">
    .service--generic
    {
    }
</style>